import {
  MultiSelect as MantineMultiSelect,
  type MultiSelectProps,
} from "@mantine/core";
import { useMemo } from "react";
import { normalizeSelectData } from "src/utils/mantineComboboxData";

export type { MultiSelectProps };

function MultiSelect({ data, ...props }: MultiSelectProps) {
  const normalizedData = useMemo(
    () => (data ? normalizeSelectData(data) : data),
    [data],
  );

  return <MantineMultiSelect {...props} data={normalizedData} />;
}

export default MultiSelect;
